import { messageConstants as constants } from '../_constants/message.constants';

export const initialState = {
  isSending: false,
  isLoading: false,
  collection: [],
  message: ''
}

export function messages(state = initialState, action) {
  if (action.type === constants.MSG_INIT_STATE) {
    return {
      isSending: false,
      isLoading: false,
      collection: [],
      message: ''
    }
  }

  if (action.type === constants.MSG_ADD_MESSAGE) {
    return {
      ...state,
      collection: [
        action.message,
        ...state.collection
      ]
    }
  }

  if (action.type === constants.MSG_SET_MESSAGE) {
    return {
      ...state,
      message: action.message
    }
  }

  if (action.type === constants.MSG_SEND_SUCCESS) {
    return {
      ...state,
      isSending: false,
      message: ''
    }
  }

  if (action.type === constants.MSG_SEND_REQUEST) {
    return {
      ...state,
      isSending: true
    }
  }

  if (action.type === constants.MSG_GETALL_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      collection: action.collection
    }
  }

  if (action.type === constants.MSG_GETALL_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  return state;
}